export default __webpack_public_path__ + "static/media/0015.f1903403.svg";